import {
  Directive,
  Input,
  TemplateRef,
  ViewContainerRef
} from '@angular/core';
import { Store, select } from '@ngrx/store';
import { getSessionAuthData } from '../states/session-auth/session-auth.selectors';
import { Subject, takeUntil } from 'rxjs';
import { sessionAuthData } from '../interfaces/states-data';
import { JwtHelperService } from '@auth0/angular-jwt';
// import { UisrAuthService } from '../services/uisr-auth.service';

@Directive({ selector: '[appValidateAccess]'})
export class ValidateAccessDirective {


  protected ngUnsubscribe: Subject<void> = new Subject<void>();

  // Json de tokens
  accessTokenData: any = null;
  refreshTokenData: any = null;

 // Auth States
 sessionAuthState: sessionAuthData = { loggedIn: false };
 sessionExist: boolean = false;

  constructor(
    private templateRef: TemplateRef<any>,
    private viewContainer: ViewContainerRef,
    private store: Store<any>,
    private jwtHelper: JwtHelperService,
    // private authService: UisrAuthService
  ) { 
    this.store.pipe(select(getSessionAuthData), takeUntil(this.ngUnsubscribe))
    .subscribe((data: sessionAuthData) => {

      // console.warn(`%c -------> loggedIn: ${data.loggedIn}`, 'color: white');

      // Se guarda en local storage el estado obtenido
      localStorage.setItem('sessionAuthState', JSON.stringify(data));

      // Se guarda en el componente local el estado obtenido
      this.sessionAuthState = data;

      // Se desencriptan los tokens
      this.refreshTokenData = this.sessionAuthState.refresh_token ? this.jwtHelper.decodeToken(this.sessionAuthState.refresh_token || '') : null;
      this.accessTokenData = this.sessionAuthState.access_token ? this.jwtHelper.decodeToken(this.sessionAuthState.access_token || '') : null;

      // Si el token se desencripta correctamente
      if (!this.sessionExist && this.accessTokenData && this.refreshTokenData) {
        // console.warn('%c -------> Session Exist', 'color: white');
        this.sessionExist = true;
      } 
    });
  }

  @Input()
  set appValidateAccess(action: string | null | undefined) { 
    // console.log('sessionAuthState', this.sessionAuthState)

    // console.log(action)
    if (!action || this.sessionAuthState.permissions?.includes(action)) {
    // if (true) {
      this.viewContainer.createEmbeddedView(this.templateRef);
    } else {
      this.viewContainer.clear();
    }
  }
}
